import React from "react";
import { IoCheckmarkCircle } from "react-icons/io5";
import { paymentSummary } from "../../../../resources/js/images";
import H3 from "../../../../shared/typography/H3";
import H4 from "../../../../shared/typography/H4";
import P from "../../../../shared/typography/P";
import Button from "../../../../shared/ui/Button";

const process = [
    "Select the payment mode, cheque or online transfer",
    "Choose the pending receipt from the payment list ",
    "Make the payment online or fill the cheque",
    "After the payment, upload the payment receipt or cheque image",
];
const Summary = ({ onClick }) => {
    return (
        <div className="flex flex-wrap justify-between gap-2.4 xl:pt-4 lg:gap-2 xl:gap-3 xl:p-2.8">
            <div className="flex flex-col-reverse lg:flex-col justify-center w-full lg:w-5/12 xl:w-5/12 gap-y-2.4 lg:gap-y-1">
                <div className="flex justify-center">
                    <img
                        src={paymentSummary}
                        alt="paymentSummary"
                        className=" h-[190px] lg:h-[280px] w-auto"
                    />
                </div>
                <H3 className="text-center">
                    Glad you’re choosing solar with HyperSrot
                </H3>
            </div>
            <div className="w-full lg:w-6/12 xl:w-6/12">
                <div className="text-center bg-gray-100 py-1 rounded-sm mb-2.4 xl:mb-2.8">
                    <H4 className="sm:text-base 2xl:text-base ">
                        Online Payment Process
                    </H4>
                </div>
                {process.map((item, index) => (
                    <div className="flex items-center gap-1.5 mb-2.4">
                        <div>
                            <IoCheckmarkCircle className="text-xl text-primary" />
                        </div>

                        <P className="xl:text-sm 2xl:text-sm">{item}</P>
                    </div>
                ))}
                <Button onClick={onClick} className=" mt-4 xl:mt-6.2 w-full">
                    Continue
                </Button>
            </div>
        </div>
    );
};

export default Summary;
